import React, { useEffect, useState } from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

// custom components
import { CustomSpinner } from '_atoms';
import { CustomModal } from '_molecules';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { getFlightAverage, selectFlightInformation, selectFlightAverage, updateFlightForecastRecord, selectSelectedFlight, selectFlightAverageError, selectFlightAverageStatus, selectFlightForecastRecordStatus, selectFlightForecastRecordError, createFlightSchedule} from '_redux/slices/flights/flight-information';

// styling
import { Colors } from '_styles';


// tremor
import { Title as TremorTitle, Flex } from '@tremor/react';

// icons
import { MdError } from "react-icons/md";
import { CiCirclePlus } from "react-icons/ci";

function splitIATACodes(str) {
    // Split the string by underscore
    const parts = str.split('_');
    
    // Assign the first part to origin
    const origin = parts[0];
    
    // Assign the second part to destination
    const destination = parts[1];
    
    return { origin, destination };
}
function separateFlightNumber(flight) {
    // Extract the first two characters as the carrier code
    const carrierCode = flight.slice(0, 2);
    // Extract the rest of the string as the flight number
    const flightNumber = flight.slice(2);

    return {
        carrierCode: carrierCode,
        flightNumber: flightNumber
    };
}

const FlightAveragesModal = (props) => {

    const dispatch = useDispatch();

    const flightInformation = useSelector(selectFlightInformation);
    const flightAverage = useSelector(selectFlightAverage);
    const selectedFlight = useSelector(selectSelectedFlight);

    const flightAverageStatus = useSelector(selectFlightAverageStatus);
    const flightAverageError = useSelector(selectFlightAverageError);

    // create flight record
    const createRecordStatus = useSelector(selectFlightForecastRecordStatus);
    const createRecordError = useSelector(selectFlightForecastRecordError);

    // local states
    const [changed, setChanged] = useState(false);                              // show button to confirm changes 
    const [selectedForecastMethod, setForecastMethod] = useState(null);
    const [showError, setShowError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [updated, setUpdated] = useState(false);

    // vals
    const [average, setAverage] = useState(0);
    const [departureTime, setDepartureTime] = useState(null);
    const [arrivalTime, setArrivalTime] = useState(null);
    const [origin, setOrigin] = useState(null);
    const [destination, setDestination] = useState(null)

    const handleClose = () => {
        // check for preffered forecast method
        if(selectedForecastMethod != null){
            // need to update db with selected forecast method
            dispatch(updateFlightForecastRecord({
                flightNumber: flightInformation.carrierCode + flightInformation.flightNumber,
                'origin': flightInformation.origin,
                'destination': flightInformation.destination,
                'departureDate': flightInformation.departureDate,
                forecastMethod: selectedForecastMethod,
            }))
        }
    }

    useEffect(() => {
        if (selectedFlight) {
            refreshFlightAverage()
        }
    }, []);

    useEffect(() => {
        // console.log('flightAverage ', flightAverage)
        if(flightAverage == null && flightAverageError != null){
            // error getting flight info
            //console.log('error getting flight average info', flightAverageError)
        }
        if(flightAverage && flightAverage.forecastMethod){
            //console.log('setting click to be ', flightAverage.forecastMethod)
            setForecastMethod(flightAverage.forecastMethod)
        }
    }, [flightAverage]);

    useEffect(() => {
        // console.log('createRecordStatus', createRecordStatus);
        if(createRecordStatus == 'succeeded' && updated){
            setShowModal(false)
        }
    }, [createRecordStatus]);

    useEffect(() => {
       // console.log('createRecordError', createRecordError);
    }, [createRecordError]);

    const refreshFlightAverage = () => {


        // console.log('refreshing flight average...', selectedFlight);

        if(selectedFlight && selectedFlight.document){
            const { origin, destination } = splitIATACodes(selectedFlight.document);

            let params = {
                flightNumber: selectedFlight.flight,
                departureDate: selectedFlight.date,
                origin: origin,
                destination: destination,   
            }
        
            //console.log('PARAMS', params);

            dispatch(getFlightAverage(params));
        }
        else if(selectedFlight && flightInformation && flightInformation.origin){
            let params = {
                flightNumber: selectedFlight.flight,
                departureDate: selectedFlight.date,
                origin: flightInformation.origin,
                destination: flightInformation.destination,   
            }

            dispatch(getFlightAverage(params));
        }
        else {
            // document does not exist, cannot display average
            setShowError('Missing flight from schedule, no averaging data exists');
        }

    
    }

    const handleRadioChange = (e) => {
        setChanged(true);
        setForecastMethod(e.target.id)
    }

    const addSchedule = () => {
        console.log('add schedule')
        // show modal
        setShowModal(true)

    }

    // adding flight to schedule manually
    const addToForecast = () => {
        
        //console.log('selected flight ', selectedFlight);
        //console.log('flight info ', flightInformation)

        // split flight number
        let result = separateFlightNumber(selectedFlight.flight)
        setUpdated(true);

        /*
        DEPRICATED
        
        dispatch(createFlightSchedule({
            'departureDate': selectedFlight.date,
            'average': average,
            'carrierCode': result.carrierCode,
            'flightNumber': result.flightNumber,
        }))
        */
        
    }

    return (
        <div>



        </div>
    );
};

export default FlightAveragesModal;
